import { render } from "./FormBenefits.vue?vue&type=template&id=158f7e42&scoped=true"
import script from "./FormBenefits.vue?vue&type=script&lang=js"
export * from "./FormBenefits.vue?vue&type=script&lang=js"

import "./FormBenefits.vue?vue&type=style&index=0&id=158f7e42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-158f7e42"

export default script